import { floripa2026 } from "./floripa-2026";
import { saopaulo2026 } from "./saopaulo-2026";
import type { Edition } from "./types";

export const EDITIONS: Record<string, Edition> = {
  [saopaulo2026.slug]: saopaulo2026,
  [floripa2026.slug]: floripa2026,
};

function pickDefaultEditionSlug(): string {
  const editions = Object.values(EDITIONS);
  if (editions.length === 0) {
    throw new Error("No editions registered in EDITIONS.");
  }
  return editions.reduce((a, b) =>
    a.eventStartDate >= b.eventStartDate ? a : b,
  ).slug;
}

export const DEFAULT_EDITION = pickDefaultEditionSlug();

export function getEdition(slug: string): Edition {
  const edition = EDITIONS[slug];
  if (!edition) {
    throw new Error(
      `Unknown edition "${slug}". Known editions: ${Object.keys(EDITIONS).join(", ")}.`,
    );
  }
  return edition;
}

export function listEditions(): { slug: string; label: string }[] {
  return Object.values(EDITIONS).map((e) => ({
    slug: e.slug,
    label: `${e.city} (${e.editionDates})`,
  }));
}

export type { Edition } from "./types";
